import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';

import { userLogout, forbiddenAccess, checkVersionMisMatch } from './auth';

const request = superagent.agent().set('ETag', window.Config.APP_VERSION)
  .use(function (req) {
    req.on('response', function (res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        userLogout();
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });

export function getWebBookingPreferenceStart() {
  return {
    type: types.GET_WEBBOOKING_PREFERENCE_START,
  };
}

export function getWebBookingPreferenceSuccess(webchatpreference) {
  return {
    type: types.GET_WEBBOOKING_PREFERENCE_SUCCESS,
    webchatpreference,
  };
}

export function getWebBookingPreferenceFail() {
  return {
    type: types.GET_WEBBOOKING_PREFERENCE_FAIL,
  };
}

export function getWebBookingPreference(business_id) {
  return (dispatch, getState) => {
    dispatch(getWebBookingPreferenceStart());
    request.get(`${window.Config.API_URL}/business/preferences/webChat/preferences`).withCredentials().set('X-Request-ID', uuidv4())
      .ok((res) => res.status < 500)
      .then((resp) => {
        console.log('Preference---->', resp);
        if (resp.statusCode === 200) {
          dispatch(getWebBookingPreferenceSuccess(resp.body));
          dispatch(checkVersionMisMatch(resp.headers));
        } else {
          dispatch(getWebBookingPreferenceFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getWebBookingPreferenceFail());
      });
  };
}

export function postWebBookingPrefStart() {
  return {
    type: types.POST_WEBBOOKING_START,
  };
}

export function postWebBookingPrefSuccess(config) {
  return {
    type: types.POST_WEBBOOKING_SUCCESS,
    config,
  };
}

export function postWebBookingPrefFail() {
  return {
    type: types.POST_WEBBOOKING_FAIL,
  };
}

export function postWebBookingPref(action_color, background_color, logo) {
  return (dispatch, getState) => {
    const params = Object.assign(
      {},
      {
        action_color,
        background_color,
        logo,
      },
    );
    const { auth } = getState();
    dispatch(postWebBookingPrefStart());
    request.put(`${window.Config.API_URL}/business/preferences/webChat/booking_widget`).withCredentials().set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        console.log('status---->', resp);
        if (resp.statusCode === 200) {
          dispatch(postWebBookingPrefSuccess(resp.body));
        } else {
          dispatch(postWebBookingPrefFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postWebBookingPrefFail());
      });
  };
}

export function postWebBookingStatusStart() {
  return {
    type: types.POST_WEBBOOKING_STATUS_START,
  };
}

export function postWebBookingStatusSuccess(config) {
  return {
    type: types.POST_WEBBOOKING_STATUS_SUCCESS,
    config,
  };
}

export function postWebBookingStatusFail() {
  return {
    type: types.POST_WEBBOOKING_STATUS_FAIL,
  };
}

export function postWebBookingStatus(status) {
  return (dispatch, getState) => {
    const params = Object.assign(
      {},
      {
        status,
      },
    );
    const { auth } = getState();
    dispatch(postWebBookingStatusStart());
    request.put(`${window.Config.API_URL}/business/preferences/webChat/booking_widget_status`).withCredentials().set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        console.log('status---->', resp);
        if (resp.statusCode === 200) {
          dispatch(postWebBookingStatusSuccess(resp.body));
        } else {
          dispatch(postWebBookingStatusFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postWebBookingStatusFail());
      });
  };
}

export function postWebchatBookingEmailSuccess(email) {
  return {
    type: types.POST_WEBBOOKING_INSTRUCTION_SUCCESS,
    email,
  };
}
export function postWebchatBookingEmailStart() {
  return {
    type: types.POST_WEBBOOKING_INSTRUCTION_START,
  };
}
export function postWebchatBookingEmailFail() {
  return {
    type: types.POST_WEBBOOKING_INSTRUCTION_FAIL,
  };
}
export function postWebchatBookingEmails(email) {
  return (dispatch, getState) => {
    const params = Object.assign(
      {},
      {
        email,
      },
    );
    const { auth } = getState();
    dispatch(postWebchatBookingEmailStart());
    request.post(`${window.Config.API_URL}/business/preferences/webChat/email_booking_widget_instruction`).withCredentials().set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(postWebchatBookingEmailSuccess(email));
        } else {
          dispatch(postWebchatBookingEmailFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postWebchatBookingEmailFail());
      });
  };
}

export function getWebBookingWorfkflowStart() {
  return {
    type: types.GET_WEBBOOKING_WORKFLOW_START,
  };
}

export function getWebBookingWorfkflowSuccess(worklfow) {
  return {
    type: types.GET_WEBBOOKING_WORKFLOW_SUCCESS,
    worklfow,
  };
}

export function getWebBookingWorfkflowFail() {
  return {
    type: types.GET_WEBBOOKING_WORKFLOW_FAIL,
  };
}

export function getWebBookingWorfkflow() {
  return (dispatch, getState) => {
    dispatch(getWebBookingWorfkflowStart());
    request.get(`${window.Config.API_URL}/business/workflow/online_pre_booking`).withCredentials().set('X-Request-ID', uuidv4())
      .ok((res) => res.status < 500)
      .then((resp) => {
        console.log('Preference---->', resp);
        if (resp.statusCode === 200) {
          dispatch(getWebBookingWorfkflowSuccess(resp.body));
          // dispatch(checkVersionMisMatch(resp.headers));
        } else {
          dispatch(getWebBookingWorfkflowFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getWebBookingWorfkflowFail());
      });
  };
}

export function postWebBookingWorfkflowStart() {
  return {
    type: types.POST_WEBBOOKING_WORKFLOW_START,
  };
}

export function postWebBookingWorfkflowSuccess(worklfow) {
  return {
    type: types.POST_WEBBOOKING_WORKFLOW_SUCCESS,
    worklfow,
  };
}

export function postWebBookingWorfkflowFail() {
  return {
    type: types.POST_WEBBOOKING_WORKFLOW_FAIL,
  };
}

export function postWebBookingWorfkflow(workflow) {
  return (dispatch, getState) => {
    dispatch(postWebBookingWorfkflowStart());
    request.post(`${window.Config.API_URL}/business/workflow/online_pre_booking`).withCredentials().set('X-Request-ID', uuidv4())
      .send(workflow)
      .ok((res) => res.status < 500)
      .then((resp) => {
        console.log('Preference---->', resp);
        if (resp.statusCode === 200) {
          dispatch(postWebBookingWorfkflowSuccess(resp.body));
          // dispatch(checkVersionMisMatch(resp.headers));
        } else {
          dispatch(postWebBookingWorfkflowFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(postWebBookingWorfkflowFail());
      });
  };
}
